import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetMeasuresTypes} from '@/features/measures/services/measures.http.ts'

export const useGetMeasuresTypes = () => {
    return useQuery({
        queryKey: [QUERY_KEYS.MEASURE_TYPES],
        queryFn: httpGetMeasuresTypes
    })
}
